import React from 'react'

export function LocationIcon({ size = 14, color = '#007BFF' }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} fill={color} viewBox="0 0 24 24">
      <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
    </svg>
  );
}


export function RouteIcon({ size = 14, color = '#007BFF' }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} fill={color} viewBox="0 0 24 24">
      <path fill={color} d="M8.142 3.445a.32.32 0 0 1-.01-.437a2.915 2.915 0 0 1 4.279-.142l2.21 2.195a4.626 4.626 0 0 1 .053 6.432l-2.82 2.932l2.936 3.037a3.23 3.23 0 0 1 .01 4.447a.29.29 0 0 1-.42 0l-4.206-4.253a4.626 4.626 0 0 1 .01-6.453l2.8-2.816L8.143 3.44z" />
      <path fill={color} d="m11.106 10.272l1.873-1.885a3.42 3.42 0 0 1 .469 4.38l-1.595 1.652c-.6-.605-1.705-2.052-.779-4.074z" />
    </svg>
  );
}


